import axios from "axios";
import { Message } from "element-ui";

class BaseAPI {
  constructor(config) {
    this.config = {
      baseURL: `${process.env.VUE_APP_APIBASEURL}`,
      timeout: 5000000,
      withCredentials: false,
      ...config,
    };
  }

  /**
   * custome error handle function
   */
  _handleError(error) {
    // 错误统一处理
    console.log("error", error);

    // 非200情况下
    let errorMessage =
      error.Message || error.RequestMessage || "网络异常，请稍后再试";

    if (
      error.code == "ECONNABORTED" &&
      error.message.indexOf("timeout") != -1
    ) {
      errorMessage = "查询失败，请刷新页面";
    }
    Message.error({
      message: errorMessage,
    });
  }

  /**
   * Request API method
   * @param {String} method
   * @param {String} url
   * @param {Object} rBody
   * @param {Object} headers
   */
  async fetch(method, body, headers = {}) {
    return axios({
      ...this.config,
      method,
      headers,
      // include r_url, r_body
      ...body,
    })
      .then((res) => {
        // HTTPCODE 始终是 200
        // 判断 code =? 200 或者 success =? true 来验证请求是否成功
        // 处理请求类型是blob
        console.log(res);
        if (
          body.responseType &&
          body.responseType === "blob" &&
          res.status === 200
        ) {
          return Promise.resolve(res);
        }
        if (typeof res.data === "string") {
          return Promise.resolve(res.data);
        }

        if (!res || !res.data) {
          return Promise.reject(res || "Empty HttpResponse");
        }
        const { Status, Data, success, StatusCode } = res.data;
        if (res.data.ReturnState === false) {
          return Promise.reject(res.data);
        }

        // todo:继续优化
        // if (res.data.Status === -1) {
        //   return Promise.reject(res.data);
        // }

        if (Status === 200) {
          return Promise.resolve(Data);
        }
        // 文件上传
        if (success) {
          return Promise.resolve(res.data);
        }
        // HIS
        if (StatusCode === 200) {
          return Promise.resolve(res.data.Data);
        }

        if (res.status === 200) {
          return Promise.resolve(res.data);
        }

        return Promise.reject(res.data);
      })
      .catch((error) => {
        const data = error?.code || error?.response?.data || error;

        if (error.Status === 401) {
          // console.log(data);
          return Promise.reject(error);
        } else {
          this._handleError(data);
          if (error.isAxiosError) {
            return Promise.reject(error);
          } else {
            return Promise.reject(error);
          }
        }
      });
  }

  /**
   * Fetch all requests used by axios.all
   * @param {Array} requests
   * @param {Function} callback 回调函数
   */
  async fetchAll(requests, callback) {
    return axios
      .all(requests)
      .then(axios.spread(callback))
      .catch((error) => {
        // TODO
        this._handleError(error);
      });
  }

  async get(params = {}) {
    return this.fetch("GET", params);
  }

  async post(body = {}) {
    return this.fetch("POST", body);
  }

  async delete(params) {
    return this.fetch("DELETE", params);
  }
}

export default BaseAPI;
